/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobV2Resource {
    getFixupPrototypeFunction() { return TemplateJobV2Resource.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobV2Resource>): TemplateJobV2Resource {
        let obj = Object.assign(new TemplateJobV2Resource(), model);
        TemplateJobV2Resource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobV2Resource>): TemplateJobV2Resource {
        if (!model) return null;
        return TemplateJobV2Resource.newInstance(<TemplateJobV2Resource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobV2Resource) {
        if (!obj) return;

        models.TemplateJobV2Resource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobV2Resource): boolean {
        Object.setPrototypeOf(obj, TemplateJobV2Resource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Unique resource ID
     */
    resource_id: string;

    /**
     * Name of the resource
     */
    resource_name: string;

    /**
     * Type of the resource created
     */
    resource_type: string;

    /**
     * Status of the resource
     */
    status: models.TemplateJobStatus;

    /**
     * Reason for failure, if any
     */
    status_reason: string;

    /**
     * Resource operation start time
     */
    start_date: Date;

    /**
     * Resource operation end time
     */
    end_date: Date;

}
